import type { OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import type {
  Mutation,
  ProductMutationCreateDraftProductVersionArgs,
  ProductMutationDeleteDraftProductVersionArgs,
  PublishDraftProductMutationMutationVariables,
} from "@/graphql/codegen/graphql"
import {
  CreateDraftProductMutationDocument,
  DeleteDraftProductMutationDocument,
  PublishDraftProductMutationDocument,
} from "@/graphql/codegen/graphql"

export const useDraftProductVersionMutation = (): {
  createDraftProductVersion: (
    variables: ProductMutationCreateDraftProductVersionArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "product">, ProductMutationCreateDraftProductVersionArgs>>
  publishDraftProductVersion: (
    variables: PublishDraftProductMutationMutationVariables,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "product">, PublishDraftProductMutationMutationVariables>>
  deleteDraftProductVersion: (
    variables: ProductMutationDeleteDraftProductVersionArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "product">, ProductMutationDeleteDraftProductVersionArgs>>
} => {
  const [, createDraftProductVersion] = useMutation<
    Pick<Mutation, "product">,
    ProductMutationCreateDraftProductVersionArgs
  >(CreateDraftProductMutationDocument)

  const [, publishDraftProductVersion] = useMutation<
    Pick<Mutation, "product">,
    PublishDraftProductMutationMutationVariables
  >(PublishDraftProductMutationDocument)

  const [, deleteDraftProductVersion] = useMutation<
    Pick<Mutation, "product">,
    ProductMutationDeleteDraftProductVersionArgs
  >(DeleteDraftProductMutationDocument)

  return {
    createDraftProductVersion,
    deleteDraftProductVersion,
    publishDraftProductVersion,
  }
}
